import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const OptionInner = styled.div`
  ${tw`grid gap-x-3 grid-flow-col auto-cols-max items-center`};
  /* grid-template-columns: 2.5rem minmax(0, 1fr); */

  & > *:first-child {
    width: 2.5rem;
  }

  & > *:last-child {
    width: auto;
  }

  & > *:only-child {
    width: auto;
  }
`

export const OptionImage = styled.img`
  ${tw`rounded-full`};
`
